import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20abstract%20gradient%20background%20with%20gentle%20flowing%20curves%20in%20peach%20and%20cream%20tones%2C%20minimalist%20elegant%20design%2C%20subtle%20texture%2C%20peaceful%20and%20warm%20atmosphere%2C%20no%20people%2C%20abstract%20art%20style%2C%20soft%20organic%20shapes&width=1800&height=900&seq=hero-bg-xingfu&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center py-20">
          <span className="inline-block px-4 py-1.5 rounded-full text-sm font-medium bg-primary-100/80 text-primary-700 mb-6 whitespace-nowrap">
            专业 · 科学 · 温暖
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 mb-6 leading-tight">
            打造高质量
            <br className="hidden sm:block" />
            亲密关系的完整指南
          </h1>
          <p className="text-base md:text-lg text-foreground-200 max-w-2xl mx-auto leading-relaxed mb-8">
            「性福生活」不只是身体的满足，更是情感连接与心理健康的全面升华。
            我们为您提供专业、科学、温暖的亲密关系知识，
            帮助伴侣双方建立更深层的信任与默契，让每一段关系都充满活力与幸福感。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/qinggan-lianjie"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              开始探索
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full border border-foreground-200/50 text-foreground-100 font-medium text-sm hover:bg-foreground-50/10 transition-colors whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { num: '200+', label: '专业文章' },
              { num: '6', label: '内容分类' },
              { num: '50万+', label: '月访问量' },
              { num: '98%', label: '读者好评' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
                  {stat.num}
                </div>
                <div className="text-xs md:text-sm text-foreground-300 mt-1">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}